/**
 * Created On : 1st March 2018
 * Usage : Display Grid Data
 * Coprights : Johnson Controls India Pvt Ltd.
 **/
import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Platform, Loading, LoadingController } from 'ionic-angular';
import { Storage } from "@ionic/storage";
import { DecimalPipe, DatePipe } from '@angular/common';
import { GridData } from '../../../../models/grid-data';
import { GridDataService } from '../../../../services/grid-data.service';
import { AssetService } from '../../../../services/asset.service';
import { TranslateService } from "@ngx-translate/core";
@Component({
    selector: 'grid-data',
    templateUrl: 'grid-data.html',
    providers: [TranslateService]
})
export class GridDataComponent {
    @Input() duration: number;
    @Input() pointId: string;
    @Input() pointName: string;
    @Input() PointsDatatype:string;
    @Output() hideGrid = new EventEmitter();
    public access_token: string;
    public fetchDataSpinner: Loading;
    public gridData: GridData[] = [];
    public selectedPointName: string;
    public isDateAsc: boolean = false;
    public isValueAsc: boolean = false;
    public lang: string;
    constructor(
        private platform: Platform,
        private storage: Storage,
        private loadingCtrl: LoadingController,
        private gridDataService: GridDataService,
        private assetService: AssetService,
        public translate: TranslateService
    ) {

    }
    ngOnInit() {
        this.selectedPointName = this.pointName;
        this.lang =sessionStorage.getItem("lang");
        let type;
        switch (this.duration) {
            case 5: {
                type = '5d';
                break;
            }
            case 12: {
                type = '12h';
                break;
            }
            case 24: {
                type = '24h';
                break;
            }
            case 2: {
                type = '2d';
                break;
            }
        }
        if (this.platform.is("mobileweb") || this.platform.is("core")) {
            this.access_token = sessionStorage.getItem('access_token');
            this.getGridData(this.access_token, this.assetService.asset.id, this.pointId, this.PointsDatatype,type);
        }
        else {
            this.storage.get('access_token').then((token) => {
                this.access_token = token;
                this.getGridData(this.access_token, this.assetService.asset.id, this.pointId, this.PointsDatatype,type);
            })
        }
    }
    getGridData(token, assetId, pointId, PointsDatatype,type) {
        this.fetchDataSpinner = this.loadingCtrl.create({
            content: this.translate.instant('Fetchingdata'),
            spinner: 'bubbles'
        });
        this.fetchDataSpinner.present();
        this.gridDataService.getGridData(token, assetId, pointId, PointsDatatype, type,this.lang)
            .subscribe((data) => {
                if (data && data.length > 0) {
                    this.gridData = data;
                }
                this.fetchDataSpinner.dismiss();
            }, (error) => this.fetchDataSpinner.dismiss());
    }

    hideGridData() {
        this.hideGrid.emit(false);
    }

    sortValues() {
        let self = this;
        this.isValueAsc = !this.isValueAsc;
        this.gridData.sort((val1, val2) => {
            let x = Number(val1.value)
            let y = Number(val2.value)
            if (!self.isValueAsc) {
                return x > y ? -1 : x < y ? 1 : 0;
            } else {
                return x > y ? 1 : x < y ? -1 : 0;
            }

        });
    }

    sortDate(){
        let self = this;
        this.isDateAsc = !this.isDateAsc;
        this.gridData.sort(function (a, b) {
            let x = Date.parse(a.timestamp);
            let y = Date.parse(b.timestamp);
            if (!self.isDateAsc) {
                return x > y ? -1 : x < y ? 1 : 0;
            } else {
                return x > y ? 1 : x < y ? -1 : 0;
            }

        });
    }

}



// WEBPACK FOOTER //
// ./src/components/trends/trends-components/grid-data/grid-data.ts